<template>
  <modal :show.sync="visible" @update:show="handleModalClose">
    <div class="box">
      <div slot="header" class="index-dependency-warning-header">
        <span class="icon has-text-warning">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Cảnh báo
      </div>
      
      <div class="content index-dependency-warning-content">
        <p class="index-dependency-warning-message">{{ warningMessage }}</p>
        
        <div v-if="dataInputNames.length > 0" class="dependency-section">
          <strong>DataInput:</strong>
          <ul class="dependency-list">
            <li v-for="name in dataInputNames" :key="name" class="dependency-item">
              {{ name }}
            </li>
          </ul>
        </div>
        
        <div v-if="forwarderNames.length > 0" class="dependency-section">
          <strong>Forwarder:</strong>
          <ul class="dependency-list">
            <li v-for="name in forwarderNames" :key="name" class="dependency-item">
              {{ name }}
            </li>
          </ul>
        </div>
      </div>

      <div slot="footer" class="field is-grouped is-grouped-right">
        <div class="control">
          <button 
            type="button" 
            class="button is-primary"
            @click="confirmAction"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from '@cyradar/ui'

/**
 * IndexDependencyWarning Component
 * 
 * Displays a warning dialog when attempting to delete an index that has dependencies.
 * Shows which DataInput and Forwarder configurations are using the index.
 */
export default {
  name: 'IndexDependencyWarning',
  components: {
    Modal
  },
  props: {
    /**
     * Controls the visibility of the modal
     */
    show: {
      type: Boolean,
      default: false
    },
    /**
     * List of DataInput names that reference the index
     */
    dataInputNames: {
      type: Array,
      default: () => []
    },
    /**
     * List of Forwarder names that reference the index
     */
    forwarderNames: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    /**
     * Generates the warning message based on the dependency information
     */
    warningMessage() {
      return 'Không xóa được chỉ mục này, do đang được cấu hình ở:'
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        this.visible = newValue
      }
    },
    visible(newValue) {
      this.$emit('update:show', newValue)
    }
  },
  methods: {
    /**
     * Handles the confirmation action (closes the dialog)
     */
    confirmAction() {
      this.visible = false
      this.$emit('confirm')
    },

    /**
     * Handles modal close events (ESC key, click outside)
     */
    handleModalClose(value) {
      if (!value) {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style scoped>
/* Enhanced header styling with warning icon */
.index-dependency-warning-header {
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.index-dependency-warning-content {
  min-height: 120px;
  padding: 1.5rem 0;
}

.index-dependency-warning-message {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-weight: 500;
  color: #4a4a4a;
}

.dependency-section {
  margin-bottom: 1rem;
}

.dependency-section strong {
  color: #363636;
  font-weight: 600;
}

.dependency-list {
  margin-top: 0.5rem;
  margin-left: 1rem;
  list-style-type: disc;
}

.dependency-item {
  margin-bottom: 0.25rem;
  color: #4a4a4a;
  font-weight: 500;
}

/* Dark theme support */
.theme-dark .index-dependency-warning-message,
.theme-dark .dependency-item {
  color: #b5b5b5;
}

.theme-dark .dependency-section strong {
  color: #dbdbdb;
}
</style>
